import { onMounted, onBeforeUnmount } from 'vue'

export function useClickOutside(targetRef, callback, options = {}) {
	const { closeOnEsc = false } = options

	const handleClick = (event) => {
		if (!targetRef.value) return

		if (!targetRef.value.contains(event.target)) {
			callback(event)
		}
	}

	const handleKey = (event) => {
		if (closeOnEsc && event.key === 'Escape') {
			callback(event)
		}
	}

	onMounted(() => {
		document.addEventListener('click', handleClick)
		if (closeOnEsc) {
			document.addEventListener('keydown', handleKey)
		}
	})

	onBeforeUnmount(() => {
		document.removeEventListener('click', handleClick)
		if (closeOnEsc) {
			document.removeEventListener('keydown', handleKey)
		}
	})
}
